'use client';
import { Typography } from '@snack-uikit/typography';

import { useAppNavigationCtx } from '@/hooks/ctx';

import s from './styles.module.scss';
import { UsefulLink } from './UsefulLink';
import { makeUsefulPagesConfig } from './utils';

export function NotFound() {
  const { appNavigationConfig } = useAppNavigationCtx();
  const usefulPagesConfig = makeUsefulPagesConfig(appNavigationConfig);

  return (
    <div className={s.not_found_container}>
      <Typography.SansDisplayL className={s.not_found_title_text}> 404 </Typography.SansDisplayL>
      <Typography.SansTitleL className={s.not_found_title_text}> Такой страницы нет </Typography.SansTitleL>
      <Typography.SansTitleM> Но есть другие полезные страницы </Typography.SansTitleM>
      {usefulPagesConfig.map(link => (
        <UsefulLink key={link.label} {...link} />
      ))}
    </div>
  );
}
